//imports
import Headroom from "headroom.js";
import GLightbox from 'glightbox';
import 'slick-carousel';
import AOS from 'aos';

// lazysizes
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';



$(document).ready(function($){



  //GLIGHTBOX
 const lightbox = GLightbox();
  var options = {

     offset: {
         up: 0,
         down: 0
     },
     // scroll tolerance in px before state changes
     tolerance : 0,

 };

 //HEADROOM JS


 var options = {
  
  // or you can specify offset individually for up/down scroll
  offset: {
      up: 400,
      down: 500
  },
 
 
  
};


  var element = document.querySelector("header");
  var headroom  = new Headroom(element,options);
  // initialise
  headroom.init();

  //AOS
  AOS.init();





   $('.slider__wrapper').slick({
    rows : 0,
     dots: true,
     infinite: true,
     speed: 500,
     fade: true,
     cssEase: 'linear',
     arrows : false,
     
   });



   $(".prev-btn").click(function () {
		$(".slider__wrapper").slick("slickPrev");
	});

	$(".next-btn").click(function () {
		$(".slider__wrapper").slick("slickNext");
	});
  $(".prev-btn").click(function () {
   $(".testimonials__wrapper").slick("slickPrev");
 });

 $(".next-btn").click(function () {
   $(".testimonials__wrapper").slick("slickNext");
 });
	$(".prev-btn").addClass("slick-disabled");

  $(".slider__wrapper").on("afterChange", function () {
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".prev-btn").addClass("slick-disabled");
		} else {
			$(".prev-btn").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".next-btn").addClass("slick-disabled");
		} else {
			$(".next-btn").removeClass("slick-disabled");
		}
	});

 



});
